export const TICKET_PURCHASE_STRINGS = {
  CANCEL: '취소',
  TICKET_UNIT: '개',
  BADGE_LABEL_PURCHASE: '인증권 구매',
  PURCHASE_TITLE: '소유자 인증권을 얼마나 충전할까요?',
  PURCHASE_DESC: '충전할 인증권 수량을 선택해주세요',
  PURCHASE_QUANTITY_LABEL: '구매수량 선택',
  PURCHASE_DIRECT_INPUT_CHIP: '직접입력',
  PURCHASE_DIRECT_INPUT_LABEL: '직접 입력',
  PURCHASE_PRICE_LABEL: '금액',
  PURCHASE_QTY_LABEL: '수량',
  PURCHASE_TOTAL_LABEL: '합계',
  PURCHASE_BUTTON: '인증권 구매하기',
  ERROR_NO_BUYABLE: '구매할 수 있는 상품이 없습니다.',
  ERROR_PURCHASE_FAIL: '인증 요청에 실패하였습니다.',
};
